module.exports = __webpack_public_path__ + "fonts/RenaultLifeOldStyle-Bold.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fonts/old-style/RenaultLifeOldStyle-Bold.ttf
// module id = 341
// module chunks = 0